import React from 'react';
import AppNavigationLink from "./AppNavigationLink";
import orangeLogoImg from "../../../resources/images/app/branding/orange-logo.svg";
import logoTextImg from "../../../resources/images/app/branding/invert-affimob.svg";

export default function SidebarNavigationView({
    currentPath,
    isMenuOpen,
    links,
    onToggleOpenMenu,
    onNavigateToLink,
}) {
    return (
        <div className={"main-menu" + (isMenuOpen ? " open" : "")} id="main-menu">
            <div className="button-menu" onClick={onToggleOpenMenu}>
                <div className={(isMenuOpen ? "arrow-left" : "arrow-right") + " icon-menu"}/>
            </div>
            <div className={"title" + (isMenuOpen ? " open" : "")}>
                <img src={orangeLogoImg} alt="" className="logo-icon"/>
                <img src={logoTextImg} alt="" className="logo-text"/>
            </div>
            <div className="nav-items" id="nav-items">
                {links.map((link) => (
                    <AppNavigationLink
                        key={link.key}
                        {...link}
                        currentPath={currentPath}
                        onClick={onNavigateToLink(link.href)}
                        isMenuOpen={isMenuOpen}
                        href={link.href}
                    />
                ))}
            </div>
        </div>
    );
}
